import Vue from 'vue';

const state = {
    newsList: {}
};

const getters = {
    newsList: state => {
        return state.newsList;
    }
};

const mutations = {
    setNewsList: (state, data) => {
        state.newsList = data;
    }
}

const actions = {
    getNewsList: ({ commit }) => {
        Vue.http.get('getNewsList/').then(response => {
            commit('setNewsList', response.data);
        },response => {
            commit('setNewsList', response.data);
        });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/news.js